import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { SiteAdapter, TranslatePipe } from "@spartacus/core";
import { Subscription } from "rxjs";
import { CheckoutFlowService } from "src/app/knbr-dual-checkout/checkout-flow-service";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
import { NgClass } from "@angular/common";
import { FormErrorsComponent } from "@spartacus/storefront";
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
    selector: "knbr-cwt-checkout-delivery-address",
    templateUrl: "./cwt-checkout-delivery-address.component.html",
    imports: [
        ReactiveFormsModule,
        NgClass,
        FormErrorsComponent,
        NgSelectComponent,
        TranslatePipe,
    ],
})

export class CwtCheckoutDeliveryAddressComponent implements OnInit, OnDestroy {
  deliveryAddressForm!: FormGroup;
  deliveryMode: string;
  isPickperson: boolean = false;
  sectionCompleted = false;
  sectionActive = true;
  stateData: any[];
  currentUrl = '';
  private subscriptions = new Subscription();
  showInvalidZipcodeMsg = false;
  plantId: string;

  plantIds = []

  constructor(
    private fb: FormBuilder,
    protected checkoutFlowService: CheckoutFlowService,
    private KnBrCheckoutService: KnBrCheckoutService,
    private router: Router,
    private siteAdapter: SiteAdapter,
    private cd: ChangeDetectorRef
  ) {
    this.currentUrl = this.router.url;
    if (this.currentUrl.includes('/checkout')) {
      this.KnBrCheckoutService.isCheckout$.next(true);
    }
  }

  ngOnInit(): void {
        this.subscriptions.add(
          this.KnBrCheckoutService.getPlantIdListData().subscribe(
            (resp: any) => {
              const result = resp[0]
                .split(";")
                .filter(Boolean)
                .map((s) => {
                  const [name, code] = s.split(":");
                  return { name, code };
                });
              this.plantIds = result;
            },
          ),
        );
    this.initForm();
    this.getcurrentURL();
    const deliveryAddressSub = this.checkoutFlowService
      .getCart()
      .subscribe((res) => {
        const data = res;
        if (data) {
          this.deliveryAddressForm.patchValue({
            firstName: data.deliveryContactInfo?.firstName || "",
            lastName: data.deliveryContactInfo?.lastName || "",
            phoneNumber: this.formatPhone(data.deliveryContactInfo?.mobileNumber),
            zipCode: this.trimPostalCode(data.deliveryAddress?.postalCode) || "",
            state: data.deliveryAddress?.region?.isocode?.startsWith('US') ? data.deliveryAddress?.region?.isocode : '',
            city: data.deliveryAddress?.town || "",
            line1: data.deliveryAddress?.line1,
            line2: data.deliveryAddress?.line2,
          });
          this.deliveryAddressForm.markAllAsTouched()
          if (!this.isPickperson) {
            this.validateZip();
          }
          this.cd.detectChanges();
        }
      });
    this.subscriptions.add(deliveryAddressSub);

    if (this.isPickperson) {
      this.deliveryAddressForm.get("line1")?.disable();
      this.deliveryAddressForm.get("line2")?.disable();
      this.deliveryAddressForm.get("city")?.disable();
      this.deliveryAddressForm.get("state")?.disable();
      this.deliveryAddressForm.get("zipCode")?.disable();
    }
 
    this.checkoutFlowService.mode$.subscribe((mode) => {
      this.deliveryMode = mode;
    });
  }

  trimPostalCode(zipcode) {
    if (zipcode) {
      return zipcode.length > 5 ? zipcode.substring(0, 5) : zipcode;
    }
    return zipcode;
  }

  validateZip() {
    const zipCode = this.deliveryAddressForm?.get('zipCode').value;
    this.KnBrCheckoutService.isValidZipCode(zipCode).subscribe((res: any) => {
      if (res && res?.carlisleFacilityZips?.length) {
        this.plantId = res.carlisleFacilityZips[0]?.warehouses?.codes;
        this.showInvalidZipcodeMsg = false;
        this.cd.detectChanges();
      } else {
        this.showInvalidZipcodeMsg = true;
        this.cd.detectChanges();
      }
    });
  }

  initForm(): void {
    this.deliveryAddressForm = this.fb.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      phoneNumber: [
        "",
        [Validators.required, Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)],
      ],
      line1: ["", [Validators.required]],
      line2: [""],
      city: ["", Validators.required],
      state: ["", Validators.required],
      zipCode: ["", Validators.required],
    });
  }

  getcurrentURL() {
    if (this.router.url.includes("pickup-person")) this.isPickperson = true;
      if (!this.isPickperson) {
      const regionSub= this.siteAdapter.loadRegions("US").subscribe((res) => {
        if (res) {
          this.stateData = res.filter((eachItem) =>
            eachItem.isocode.startsWith("US")
        );
        this.cd.detectChanges()
        }
      });
        this.subscriptions.add(regionSub);
    }
  }

  isInvalid(controlName: string): boolean {
    const control = this.deliveryAddressForm.get(controlName);
    return !!(control && control.invalid && control.touched);
  }

  formatPhoneNumber() {
    const phoneCtrl = this.deliveryAddressForm.get("phoneNumber");
    if (phoneCtrl) {
      let digits = phoneCtrl.value.replace(/\D/g, "");
      if (digits.length > 10) digits = digits.slice(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(
          3,
          6
        )}-${digits.slice(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      }
      phoneCtrl.setValue(formatted, { emitEvent: false });
    }
  }

  formatPhone(raw: string): string {
    const digits = raw?.replace(/\D/g, "").slice(0, 10);
    if (digits?.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return raw;
  }

  onSubmit(): void {
    if (this.deliveryAddressForm.valid) {
      this.sectionCompleted = true;
      this.sectionActive = false;
      const routeValue = this.getRouteInfo();
      this.checkoutFlowService.markCompleted(this.deliveryMode, routeValue);

      const { firstName, lastName, phoneNumber, zipCode, city, state, line1, line2 } = this.deliveryAddressForm.value;
      const cleanedPhoneNumber = phoneNumber.replace(/\D/g, "");

      if (this.deliveryMode === "pickUp") {
        const payload = { firstName, lastName, phoneNumber: cleanedPhoneNumber };

        this.subscriptions.add(
          this.KnBrCheckoutService.updatePickupInfo(payload).subscribe({
            next: (res) => {
              this.router.navigateByUrl("checkout/pickup-store");
            },
            error: (err) =>
              console.error("Update pickup person api failed:", err),
          })
        );
      } else if (this.deliveryMode === "delivery") {
        const payload = {
          country: { isocode: "US" },
          firstName: firstName,
          lastName: lastName,
          line1: line1,
          line2: line2,
          town: city,
          region: { isocode: state },
          postalCode: zipCode,
          phone: cleanedPhoneNumber,
          plant: this.getPlantIdByName(this.plantId?.toString())
        };

        this.subscriptions.add(
          this.KnBrCheckoutService.updateDeliveryAddress(payload).subscribe({
            next: (res) => {
              this.router.navigateByUrl("checkout/schedule-delivery");
            },
            error: (err) =>
              console.error("Update delivery address section Failed:", err),
          })
        );
      }
    } else {
      this.deliveryAddressForm.markAllAsTouched();
    }
  }

  getPlantIdByName(plantId) {
    return this.plantIds.find(plant => plant.name === plantId)?.code || '';
  }

  getRouteInfo() {
    const segments = this.router.url.split("/").filter(Boolean);
    const lastTwo = segments.slice(-2).join("/");
    return lastTwo;
  }

  onEdit(): void {
    this.sectionActive = true;
    this.sectionCompleted = false;
  }
  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
